const approvedDomainsConstantsAr = {
  approvedDomainsPageTitle: 'النطاقات المعتمدة',
  approvedDomainsBreadcrumb: 'النطاقات المعتمدة',
  approvedDomainsTableColumnDomain: 'النطاق',
  approvedDomainsTableColumnAction: 'الإجراء',
  approvedDomainsActionPanelBtn: 'إضافة نطاق جديد',
  approvedDomainsAddPopUpTitle: 'إضافة نطاق جديد',
  approvedDomainsUpdatePopUpTitle: 'تحديث النطاق',
  approvedDomainsDeletePopUpTitle: 'حذف النطاق',
  approvedDomainsAddBtn: 'إضافة',
  approvedDomainsUpdateBtn: 'تحديث',
  approvedDomainsDeleteBtn: 'حذف',
  approvedDomainsAddPopUpText: 'أضف نطاق جديد لتجاوز عملية الموافقة على التسجيل',
  approvedDomainsUpdatePopUpText: 'تحديث معلومات النطاق المعتمد',
  approvedDomainsDeletePopUpText: 'هل أنت متأكد من أنك تريد حذف هذا النطاق؟',
  approvedDomainsEditTooltip: 'تعديل النطاق',
  approvedDomainsDeleteTooltip: 'حذف النطاق',
  approvedDomainsActionPanelBtnTooltip: 'إضافة نطاق جديد',
  approvedDomainsTableTitleDomain: 'النطاقات',
  approvedDomainsTableTitleActions: 'الإجراءات',
  approvedDomainsDialogEmptyFieldError: 'الرجاد ادخال اسم نطاق معتمد',
};

export default approvedDomainsConstantsAr;
